import React from 'react';
import { IEventCardItem } from "../../../type/events.types";
import { CalendarOutlined, CameraOutlined, EyeOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import Locale from "../../../../../core/locale/locale";
import events from "../../../../../resources/event";
import MediaUploadButton from "../../../utils/media-upload-button";
import EventCoverImage from "../../../utils/event-cover-image";
import { replaceSpaceWithHyphen } from "../../../../../utility/utility";
import { useNavigate } from 'react-router-dom';
import { Tooltip } from "antd";
import { updateEvent } from "../../../action/events.actions";

const EventCardItem: React.FC<IEventCardItem> = ({item, onOpen, isAdmin}) => {

    const navigate = useNavigate();
    const resource = events;

    const formatDateToLong = (date: string) => (dayjs(date).format(Locale.displayDateWithMonth));

    const renderEndDate = (event: any) => (
        !dayjs(event.startDate).isSame(event.endDate) && event.endDate
    )

    function redirectToMediaPage() {
        const eventName = item.name;
        const eventFolderName = replaceSpaceWithHyphen(eventName).toLowerCase();
        navigate(`/highlights/media-hub/events/${eventFolderName}`, {state: {folderId: item.id}})
    }



    return (
        <div className="event-card" key={item.id}>
            <EventCoverImage
                isAdmin={isAdmin}
                className="event-card__image"
                event={item}
            />

            <div className="event-card__body">
                <span className="event-card__date">
                    <CalendarOutlined/>
                    {formatDateToLong(item.startDate)}
                    {renderEndDate(item) && ` - ${formatDateToLong(item.endDate)}`}
                </span>

                <h3 className="event-card__title">
                    {item.name}
                </h3>

                <p className="event-card__description">
                    {item.description}
                </p>
            </div>
            <div className={'event-card__footer'}>
                <div className="event-card__meta">
                              <span className="event-card__host">
                              <span className="event-card__host-label">Host :</span>
                               <span className="event-card__host-name"> {item.hostBy}</span>
                                   </span>
                    <Tooltip trigger={'hover'} title={'visit gallery'}>
                        <span
                            onClick={redirectToMediaPage}
                            className="event-card__photos"
                        >
                                 <CameraOutlined/>
                                 <span className="event-card__photo-count">{item.photoCount}{' Photos'}</span>
                                  </span>
                    </Tooltip>

                </div>

                <div className="event-card__actions">

                    {/*add photo button*/}
                    {isAdmin && <MediaUploadButton event={item}/>}

                    {/*view modal detail button*/}
                    <button className="event-card__btn event-card__btn--secondary"
                            onClick={() => onOpen(item)}
                    >
                        <EyeOutlined/>
                        {resource.viewDetailButtonText}
                    </button>
                </div>

            </div>
        </div>
    )
}

export default EventCardItem;
